import { render, staticRenderFns } from "./SipAgentsLoader.vue?vue&type=template&id=20d4d25a&scoped=true&"
import script from "./SipAgentsLoader.vue?vue&type=script&lang=js&"
export * from "./SipAgentsLoader.vue?vue&type=script&lang=js&"
import style0 from "./SipAgentsLoader.vue?vue&type=style&index=0&id=20d4d25a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4d25a",
  null
  
)

export default component.exports